import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { noop } from 'ui-components/default-props/noop';

import { messages } from './messages';
import style from './note-icon.module.less';
import NoteTooltipTime from '../../../../components/note-tooltip-time';

/**
 * @param {object} props
 * @param {import('../../../../prop-types/message').MessagePropType} [props.note]
 * @param {boolean} [props.disableEdit]
 * @param {import('../../../../prop-types/intl').MessageDescriptorPropType} props.titleTranslation
 * @param {(value: string) => void} [props.editNote]
 * @param {() => void} [props.stopPropagate]
 * @param {() => void} [props.onBlur]
 * @returns {JSX.Element}
 */
export const ViewNotePopoverContent = ({
  note,
  disableEdit = false,
  titleTranslation,
  editNote = noop,
  stopPropagate = noop,
  onBlur = noop,
}) => {
  const { message = '', createdDateTime = '', additionalCount = 0 } = note;

  return (
    <div
      className={style['note-tooltip']}
      data-testid='view-note-popover-content'
      onClick={stopPropagate}
      onDoubleClick={stopPropagate}
      onMouseLeave={onBlur}
    >
      <div className={style['note-title']}>
        <span className={style['title-text']}>
          <FormattedMessage {...titleTranslation} />
        </span>
        {!disableEdit && (
          <Button
            className={style['edit-note-btn']}
            data-testid='edit-note-btn'
            onClick={(e) => {
              e.stopPropagation();
              editNote();
            }}
            theme='link'
          >
            <FormattedMessage {...messages.editButton} />
          </Button>
        )}
      </div>
      <div className={style['note-body']}>
        {message.slice(0, 600).trim()}
        {message.length > 600 && <span>&hellip;</span>}
        <NoteTooltipTime createdDateTime={createdDateTime} />
        {additionalCount > 0 && (
          <div className={style['more-notes']} data-testid='more-notes'>
            <FormattedMessage {...messages.moreNotes} values={{ remainingNotes: additionalCount }} />
          </div>
        )}
      </div>
    </div>
  );
};
